import { Portal } from "@/utils/components/Portal";
import { create } from "zustand";
import { useLoadingManager } from "@/features/loading";
import { Loading } from "../Loading";

// Blocker for universal use
type LoaderState = {
  isActive: boolean;
  message: string;
  setActive: (active: boolean, message?: string) => void;
};

export const useLoaderStore = create<LoaderState>((set) => ({
  isActive: false,
  message: "",
  setActive: (active, message = "") =>
    set({ isActive: active, message }),
}));

export function LoadingOverlay() {
  const { phase } = useLoadingManager();
  const isActive = useLoaderStore((s) => s.isActive);
  const message = useLoaderStore((s) => s.message);

  if (phase.matches("done") && !isActive) return null;

  return (
    <Portal>
      <Loading message={phase.matches("done") ? message || "loading" : "preparing"} className="fixed flex w-full h-full z-50 bg-main top-0 left-0 items-center justify-center!" />
    </Portal>
  );
}
